<div class="flex items-center gap-3" role="status" aria-live="polite">
  <div class="grid size-8 place-items-center rounded-lg bg-slate-200 text-slate-700 dark:bg-slate-800 dark:text-slate-200">
    <svg aria-hidden="true" viewBox="0 0 24 24" class="size-4" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="6" width="16" height="14" rx="4" /><path d="M9 11h.01M15 11h.01M9 16h6M12 3v3" /></svg>
  </div>
  <div class="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
    <span>{{ 'thinking' | transloco }}</span>
    <span class="flex gap-1" aria-hidden="true">
      <span class="chat-processing-dot size-1.5 rounded-full bg-blue-500"></span>
      <span class="chat-processing-dot size-1.5 rounded-full bg-blue-500"></span>
      <span class="chat-processing-dot size-1.5 rounded-full bg-blue-500"></span>
    </span>
  </div>
</div>
